<script setup>
import { useStore } from "vuex";
import { computed } from "vue";

import CheckoutSummary from "./CheckoutSummary.vue";
import ProductPreviews from "../productComponents/ProductPreviews.vue";
import CheckoutMethods from "./CheckoutMethods.vue";
import ZipcodeInput from "../shippingComponents/ZipcodeInput.vue";
import CheckoutEmpty from "./CheckoutEmpty.vue";
import CheckoutCoupon from "./CheckoutCoupon.vue";
import CheckoutOutOfStock from "./CheckoutOutOfStock.vue";

const store = useStore();
const allProducts = computed(() => store.getters["product/allProducts"]);
const totals = computed(() => store.getters["checkout/totals"]);
const outOfStockItems = computed(() => store.getters["delivery/outOfStockItems"]);
const compositions = computed(() => {
  const obj = store.getters["checkout/compositions"];
  return Object.keys(obj).length === 0 ? null : obj;
});
</script>

<template>
  <div class="checkout">
    <div class="checkout__title">Order Summary</div>

    <CheckoutOutOfStock v-if="outOfStockItems.length" :out-of-stock-items="outOfStockItems" />

    <div class="checkout__container">
      <div class="checkout__previews">
        <ZipcodeInput class="checkout__zip" />

        <ProductPreviews v-if="allProducts.length && compositions" :compositions="compositions" />

        <CheckoutEmpty v-else />
      </div>

      <div class="js-checkout-forbidden-area checkout__details">
        <ZipcodeInput class="checkout__details-zip" />

        <CheckoutSummary v-if="totals" :totals="totals" />
        <CheckoutCoupon v-if="compositions" />

        <CheckoutMethods />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.checkout {
  display: grid;
  grid-row-gap: 24px;

  @include with-desktop {
    grid-row-gap: 40px;
  }

  &__title {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }

  &__container {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @include with-desktop {
      flex-direction: row;
      gap: 64px;
    }
  }

  &__previews {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @include with-desktop {
      display: block;
      flex: 1;
      flex-shrink: 0;
    }
  }

  &__zip {
    @include with-desktop {
      display: none;
    }
  }

  &__details {
    @include with-desktop {
      display: flex;
      flex-direction: column;
      gap: 24px;
      flex-shrink: 0;
      padding: 32px 40px;
      width: 100%;
      max-width: 420px;
      border-radius: 8px;
      border: 1px solid $pod-gray-modern-200;
      background: white;
      box-shadow: $pod-card-shadow;
    }
  }

  &__details-zip {
    display: none;

    @include with-desktop {
      display: block;
    }
  }
}
</style>
